<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="switchCouponType({ label: $t('common.all'), value: '' })"
              :class="{ 'selected': couponManageInfo.conditions.couponType === '' }">
              {{ $t('common.all') }}
            </li>
            <li @click="switchCouponType({ label: $t('couponManage.fullReduction'), value: '01' })"
              :class="{ 'selected': couponManageInfo.conditions.couponType === '01' }">
              {{ $t('couponManage.fullReduction') }}
            </li>
            <li @click="switchCouponType({ label: $t('couponManage.discount'), value: '02' })"
              :class="{ 'selected': couponManageInfo.conditions.couponType === '02' }">
              {{ $t('couponManage.discount') }}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="21">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('couponManage.queryCondition') }}</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input v-model="couponManageInfo.conditions.couponName"
                :placeholder="$t('couponManage.selectCouponName')" clearable style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryCouponMethod()">
                <i class="el-icon-search"></i> {{ $t('couponManage.query') }}
              </el-button>
              <el-button @click="_resetCouponMethod()">
                <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card style="margin-top: 20px;">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('couponManage.coupons') }}</span>
            <el-button type="primary" size="small" @click="_openAddCouponModal()">
              {{ $t('couponManage.add') }}
            </el-button>
          </div>
          <el-table :data="couponManageInfo.coupons" border style="width:100%" v-loading="loading">
            <el-table-column prop="couponCode" :label="$t('couponManage.couponCode')" align="center" />
            <el-table-column prop="couponName" :label="$t('couponManage.couponName')" align="center" />
            <el-table-column prop="couponType" :label="$t('couponManage.couponType')" align="center">
              <template slot-scope="scope">
                {{ scope.row.couponType === '01' ? $t('couponManage.fullReduction') : $t('couponManage.discount') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('couponManage.discountInfo')" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.couponType === '01'">
                  {{ $t('couponManage.reduce') }}￥{{ scope.row.discountAmount }}
                </span>
                <span v-else>
                  {{ scope.row.discountPercent }}%{{ $t('couponManage.off') }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="minAmount" :label="$t('couponManage.minAmount')" align="center">
              <template slot-scope="scope">
                ￥{{ scope.row.minAmount }}
              </template>
            </el-table-column>
            <el-table-column prop="totalQuantity" :label="$t('couponManage.totalQuantity')" align="center" />
            <el-table-column prop="statusCd" :label="$t('couponManage.status')" align="center">
              <template slot-scope="scope">
                {{ scope.row.statusCd === '0' ? $t('couponManage.inUse') : $t('couponManage.invalid') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('couponManage.operation')" align="center" width="240">
              <template slot-scope="scope">
                <el-button size="mini" @click="_openEditCouponModel(scope.row)">
                  {{ $t('couponManage.edit') }}
                </el-button>
                <el-button size="mini" type="danger" @click="_openDeleteCouponModel(scope.row)">
                  {{ $t('couponManage.delete') }}
                </el-button>
                <el-button size="mini" type="success" @click="_openGiveCouponModal(scope.row)">
                  {{ $t('couponManage.give') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="couponManageInfo.conditions.page"
            :page-size="couponManageInfo.conditions.row" layout="total, prev, pager, next"
            :total="couponManageInfo.total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-shop-coupon ref="addShopCoupon" @refresh="_listCoupons" />
    <edit-shop-coupon ref="editShopCoupon" @refresh="_listCoupons" />
    <delete-shop-coupon ref="deleteShopCoupon" @refresh="_listCoupons" />
    <give-coupon ref="giveCoupon" @refresh="_listCoupons" />
  </div>
</template>

<script>
import { listShopCoupon } from '@/api/coupon/couponApi'
import AddShopCoupon from '@/components/coupons/addShopCoupon/addShopCoupon'
import EditShopCoupon from '@/components/coupons/editShopCoupon/editShopCoupon'
import DeleteShopCoupon from '@/components/coupons/deleteShopCoupon/deleteShopCoupon'
import GiveCoupon from '@/components/coupons/giveCoupon/giveCoupon'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ShopCouponManage',
  components: {
    AddShopCoupon,
    EditShopCoupon,
    DeleteShopCoupon,
    GiveCoupon
  },
  data() {
    return {
      loading: false,
      couponManageInfo: {
        coupons: [],
        total: 0,
        conditions: {
          couponName: '',
          couponType: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.couponManageInfo.conditions.shopId = getShopId()
    this._listCoupons()
  },
  methods: {
    async _listCoupons() {
      this.loading = true
      try {
        const res = await listShopCoupon(this.couponManageInfo.conditions)
        this.couponManageInfo.coupons = res.data
        this.couponManageInfo.total = res.total
      } catch (error) {
        console.error('获取优惠券列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    _queryCouponMethod() {
      this.couponManageInfo.conditions.page = 1
      this._listCoupons()
    },
    _resetCouponMethod() {
      this.couponManageInfo.conditions.couponName = ''
      this.couponManageInfo.conditions.page = 1
      this._listCoupons()
    },
    handleCurrentChange(val) {
      this.couponManageInfo.conditions.page = val
      this._listCoupons()
    },
    switchCouponType(couponType) {
      this.couponManageInfo.conditions.couponType = couponType.value || ''
      this.couponManageInfo.conditions.page = 1
      this._listCoupons()
    },
    _openAddCouponModal() {
      this.$refs.addShopCoupon.open()
    },
    _openEditCouponModel(row) {
      this.$refs.editShopCoupon.open(row)
    },
    _openDeleteCouponModel(row) {
      this.$refs.deleteShopCoupon.open(row)
    },
    _openGiveCouponModal(row) {
      this.$refs.giveCoupon.open(row)
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>

